import { ShiftForSwap } from './shift-for-swap';
import { ShiftSwapStatus } from 'src/app/core/services/const';

export class SwappingStatus {
  Proposer: ShiftForSwap;
  RequestedShift: ShiftForSwap;

  // Neue Properties für offene Angebote
  SwapType: 'direct' | 'open';
  CandidateCount: number;
  AcceptedCandidates: ShiftForSwap[];
  Status: ShiftSwapStatus;
}
